import styles from "./alertbanner.module.css"
import Marquee from "react-fast-marquee";
import React, { useState, useEffect } from 'react';
function AlertBanner() {

    const [visible, setVisible] = useState(true);
    const [blocks, setBlocks] = useState([]);
    useEffect(() => {
        fetch("/api/alertbanner/get_alert_banner")
            .then(res => res.json())
            .then(data => {
                setVisible(data.visible)
                if (data.blocks && Array.isArray(data.blocks)) {
                    setBlocks(data.blocks);
                } else {
                    // console.warn("No active banner returned:", data.message);
                    setBlocks([]); // optional: reset state if nothing is returned
                }
            })
            .catch(err => {
                console.error("Failed to fetch alert banner:", err);
            });
    }, []);

    const handleMapClick = (url) => {
        window.open(url, "_blank");
    };

    if (!visible || !blocks.length) return null;
    return (
        <section>
            <Marquee className={styles.banner} pauseOnHover={true} speed={25}>
                {blocks.map((block, i) => {
                    if (block.type === "text") {
                        return <p key={i} className={styles.text}>{block.content}</p>;
                    } else if (block.type === "googleMap") {
                        return (
                            <img
                                key={i}
                                tabIndex={0}
                                src={`/assets/icons/google-map-icon.png`}
                                alt="Google Maps Icon"
                                onClick={() => handleMapClick(block.url)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        handleMapClick(block.url);
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            />
                        );
                    }
                    return null;
                })}
            </Marquee>
        </section>
    )
}

export default AlertBanner;